import { NSARouterMakerResult } from 'namirasoft-account-react';
import { NSBox, NSBoxString, NSColumn } from 'namirasoft-site-react';
import { Component, createRef } from 'react';
import QuestionEditDialog from './QuestionEditDialog';

export interface QuestionGroupFormProps extends NSARouterMakerResult
{
    start_index: number;
    questions: string[];
    getExtraQuestions: () => string[];
    getLockedQuestions: () => string[];
    onApplyQuestion: (localIndex: number, newQuestion: string) => void;
}

export interface QuestionGroupFormState
{
    updating_question: number | null;
}

class QuestionGroupForm extends Component<QuestionGroupFormProps, QuestionGroupFormState>
{
    NSBoxStringList = new Array(this.props.questions.length).fill(1).map(() => createRef<NSBoxString>());

    constructor(props: QuestionGroupFormProps)
    {
        super(props);
        this.state = { updating_question: null };
        this.setOpenDialog = this.setOpenDialog.bind(this);
    }

    setOpenDialog(updating_question: number | null)
    {
        this.setState(() => ({ updating_question }));
    }

    getAnswers(checkError?: boolean): string[]
    {
        return this.props.questions.map((_, index) => this.NSBoxStringList[index]?.current?.getValue(checkError)) as string[];
    }

    clearAnswer(localIndex: number)
    {
        this.NSBoxStringList[localIndex]?.current?.setValue("");
    }

    override render()
    {
        return (
            <NSColumn style={{ padding: "0 0.5rem", alignItems: "center" }}>
                {
                    this.props.questions.map((question, index) => (
                        <NSBoxString
                            key={index + 1}
                            ref={this.NSBoxStringList[index]}
                            title={`${this.props.start_index + index + 1}. ${question}`}
                            placeholder="Please enter your answer"
                            required
                            menu={{
                                builtin: {},
                                items: [
                                    {
                                        title: "Edit",
                                        icon: "https://static.namirasoft.com/image/concept/edit/blue.svg",
                                        onClick: () => this.setOpenDialog(index),
                                    }
                                ],
                            }}
                            style={{ width: NSBox.width.triple }}
                        />
                    ))
                }
                {
                    this.state.updating_question != null &&
                    <QuestionEditDialog
                        current_question={this.props.questions[this.state.updating_question]}
                        question_list={this.props.getExtraQuestions()}
                        locked_questions={this.props.getLockedQuestions()}
                        onApply={(new_question) =>
                        {
                            if (this.state.updating_question != null)
                                this.props.onApplyQuestion(this.state.updating_question, new_question);
                            this.setOpenDialog(null);
                        }}
                        onClose={() => this.setOpenDialog(null)}
                    />
                }
            </NSColumn >
        )
    }
}

export default QuestionGroupForm;